import Component from '@glimmer/component';
import { t } from 'ember-intl';
import type { SegmentItem } from 'lumen/utils/constants/benchmark-insight/beni-table-constant-values';

interface HotelBenchmarkInsightTablesCellsCellHierarchyItemSignature {
  Args: {
    row: SegmentItem;
    value: string;
  };
}

export default class HotelBenchmarkInsightTablesCellsCellHierarchyItem extends Component<HotelBenchmarkInsightTablesCellsCellHierarchyItemSignature> {
  get isBold(): boolean {
    const { isTotalRow, depth } = this.args.row;

    return isTotalRow || depth === 0;
  }

  <template>
    <span class={{if this.isBold "text-200--bold"}}>
      {{#if @row.isTotalRow}}
        {{t "benchmark_insight.tables.detailed_view.row.total"}}
      {{else}}
        {{@value}}
      {{/if}}
    </span>
  </template>
}
